const config = {
  boardEleBarcelonaLeadsId: 1462556551,
  boardELEpracticeClassLeadsId: 2008269311,
  groupId: 'topics',
  status: { label: 'Nueva solicitud' },
  date: { date: new Date().toISOString().split('T')[0] },
};

module.exports = config;
